class WhatIsOpenInnovationModel {
	title;
	description;
	author;

	constructor({
		 title = '', description = '', author = '',
	}) {
		this.title = title;
		this.description = description;
		this.author = author;
	}
}

export default WhatIsOpenInnovationModel;
